import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { MysqlService } from './../../services/mysql.service';
import { FileUploaderService } from './../../services/file-uploader-service';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { environment } from './../../../environments/environment';
import { FilterSettingsModel, GridComponent, GroupSettingsModel, IFilter, IFilterUI, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { DemoService } from 'src/app/demo.service';
// import { WordpressService } from 'src/app/services/wordpress.service';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { TabsModule, TabsetComponent } from 'ngx-bootstrap';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DataUtil } from '@syncfusion/ej2-data';
import { WordpressService } from 'src/app/services/wordpress.service';



@Component({
  selector: 'app-system-help-vars',
  templateUrl: './system-help-vars.component.html',
  styleUrls: ['./system-help-vars.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
})
export class SystemHelpVarsComponent implements OnInit {


  location: Location;

  @Input() brand_id: number;
  @Input() title: string = 'Upload or Select File';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;
  @Input() promotion_id: number;
  @Input() current_route: any;


       // setup as observable?
      //  @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'full'; // 

       @Input() varible_code_block_type_id? = ''; // Sets what content to show. default is PDF Vars / labels.
       @Input() template_model?: any; // send the subject communication model to set the search paremers for the variable code block grids choosers.
  
  

       @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
       isPlay: boolean = false;
  video_name: string;
  all_router_details: string;
       toggleVideo(event: any) {
         this.videoplayer.nativeElement.play();
       }



// grid settings
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
initialPage: { pageSize: number; };
activeTab: any;
activeTabId: any;
value: string;

loading: boolean;
// set an event emitter to send back to parent component
@Output() action = new EventEmitter();
@Output() actionImage = new EventEmitter();
@Output() actionVariable = new EventEmitter();
@Output() actionStr = new EventEmitter();
@Output() actionImageQR = new EventEmitter();



@Output('addFileNameFromModal') addFileNameFromModal: EventEmitter<any> = new EventEmitter();
@Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

sessionBrandId: any;
sessionUsername: any;
sessionUserId: any;
currentUserVAR: any;

div: any;
public nav: any;
public body: any;
public container: any;
// Uploader Service Vars
// public title = 'File Upload Manager - Brands';
// public imgUploaded: string;
public tableData: any;
public baseUploadURL =  environment.baseUploadURL_BrandAssets; // no trailing slash // added brand_id to HTML 
sent_brand_id: any;
wrapSettings: { wrapMode: string; };
  sent_promotion_id: number;
  promotion: any;
  promotion_page_html: any;



  woo_page: number; 
  request_query: {
      context?: string;
      page?: number;
      per_page?: number;
      search?: string;
      after?: string;
      before?: string;
      exclude?: Array<any>;
      include?: Array<any>;
      offset?: number;
      // order?: ProductOrder;
      // orderby?: ProductOrderBy | string;
      // orderby?: "id";
      orderby?:  string;
    
      parent?: Array<string>;
      parent_exclude?: Array<string>;
      slug?: string;
      status?: string;
      type?: string;
      sku?: string;
      featured?: boolean;
      category?: string;
      tag?: string;
      shipping_class?: string;
      attribute?: string;
      attribute_term?: string;
      tax_class?: string;
      in_stock?: boolean;
      on_sale?: boolean;
      min_price?: string;
      max_price?: string;
      action_list_type_id?: number;
      order_id?: number;
      job_type_affidavit_type_id?: number;
      action_list_id?:number;
      job_court_type_id?: number;
      meta_query?;
      id?;
  }
  productSlug: string;
  params: { slug: any; };
  woo_ppscoupons: any[];
  woo_ppscoupons_count: number;
  coupon_id: any;
  set_items_per_page: number;
  woo_coupon_code: any;

html_block
  variable_code_blocks_metrix_search_full: any;
  variable_code_blocks_metrix_search_full_results: any;
  new_data: any;
  search_model: any;

  model: VariableCodeBlock;


  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
  isShow_sector = false;

constructor(
  private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
  private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
  private modelService: BsModalService,
  public gfunc: GlobalFunctionsService,
  public toastr: HotToastService,
  private _demoService: DemoService,
  private woocommerce: WordpressService, 
  private http: HttpClient,
  private sanitizer: DomSanitizer
) { 
    // login vars
    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

    // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
    this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

// get the values from the context vars from model sent into the html into .ts
//let context:any = DialogRef.context;
//this.sent_brand_id = context?.brand_id;

// this.sent_brand_id = this.bsModalRef?.content?.brand_id;

this.wrapSettings = { wrapMode: 'Content' };
// syncfusion GRID OPTIONS
this.toolbarOptions = ['Search'];
this.initialPage = { pageSize: 5 };
this.filterOptions = {
type: 'Menu'
};
// this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};
// end grid options

// Location
this.location = location;

// const s = "your/string";
// const s = this.current_route;
// let s = this.current_route;
// const withoutLastChunk = this.current_route.slice(0, s.lastIndexOf("/"));
// console.log('withoutLastChunk: ', withoutLastChunk);


}

// ngOnChanges(): void {
// //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
// //Add '${implements OnChanges}' to the class.
// this.sent_brand_id = this.brand_id;
// this.sent_promotion_id = this.promotion_id;

// }

ngOnInit() {

  this.video_name = "PPSDistroHub_TemperoSystems Project.mp4";
  this.brand_id = 94; // SET TO ME AS THE DEFAULT OWNER OF THE HELP AND VARIABLE ASSETS FOR HELP
  
  
  // this.loadList(this.brand_id);
  // this.getPromotion(this.promotion_id); 

// Changed For Universal Help System
// Goiung to need more than this but us a good start and build a drop down selectr later
this.search_model = {
  is_active: 1,
  routerLink: this.current_route,

 };
this.getVariableCodeBlocksSearchFull(this.search_model)



  // static module shows pdf variables for Shipping Labels
  //   let search_model = {
  //   "is_active": true,
  //   "variable_code_block_type_id": "2",
  //   "job_type_id": "14",
  //   "job_type_location_id": "15",
  //   "job_type_court_id": "37",
  // }




  this.woo_page = 1; // sets the default page to load is one
  this.set_items_per_page = 100; // as defailt.
  // this.request_query = {
  //   // page: this.woo_page + 1,
  //   page: this.woo_page,
  //   orderby: "id",
  //   per_page: this.set_items_per_page,
  //   // per_page: 10 // gets the number of rec
  //   id: this.coupon_id
  //   }; 
  

  // console.log('PromotionID: ' + this.sent_promotion_id)

  // load the promotion
  // this.getPromotion2(this.sent_promotion_id); 

// this.refreshList();
 // this.sent_brand_id = this.brand_id;
       // refresh the upload list
       
       // when model opens
       // this.list.push('I added one here.');



this.html_block ='<div class="widget yellow-bg p-lg text-center"><div class="m-b-md"><i class="fa fa-thumbs-up fa-4x"></i><h1 class="m-xs">520</h1><h3 class="font-bold no-margins">Likes</h3><small>amount</small></div></div>';



}





// Uploader Functions
public uploadBrandImage(brand_id): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadBrandImage(formData, brand_id)
.pipe(
  this.toastr.observe({
    loading: '... monkey working ...)',
    success: '🚀',
    error: '😡'
 })
 )
.subscribe(res => {
this.toastr.success('File Uploaded Successfully.');
this.dataLoaded(res);
this.refreshList();
});


}


// Uploader Functions
public uploadImage(): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadImage(formData).subscribe(
res => {
  this.toastr.success('File Uploaded Successfully.')
  this.dataLoaded(res)
  
}
);
}


dataLoaded(data: any): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='hidden';
// this.imgUploaded = data._body;
this.refreshList();

}

refreshList(): void {
this.fileUploader.getBrandsList(this.brand_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
// this.tableData = data.json();
this.tableData = data;
}

// end uploader functions


loadList(brand_id): void {
this.fileUploader.getBrandsList(brand_id).subscribe(res=> this.displayTableData(res));

}



public clickOk(filename) {
// tslint:disable-next-line:indent
console.log('Clicked...');
this.loading = true;
// this.action.emit(true); /// << here you can send object  instead of true
console.log('Clicked...' , filename);
// this.action.emit(filename); /// << here you can send object  instead of true


this.addFileNameFromModal.emit('asdfasdfasdfsadfsd');


//  this.closeParentModelDefault.emit();
}


public clickFile(filename) {
// tslint:disable-next-line:indent
this.loading = true;
this.action.emit(filename); /// << here you can send object  instead of true
this.bsModalRef.hide();
}


public insertFile(fileurl) {
// tslint:disable-next-line:indent
this.loading = true;
this.action.emit(fileurl); /// << here you can send object  instead of true
this.bsModalRef.hide();
}


public insertVariable(fileurl) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.actionVariable.emit(fileurl); /// << here you can send object  instead of true
  this.bsModalRef.hide();
  }


public insertImage(fileurl) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.actionImage.emit(fileurl); /// << here you can send object  instead of true
  this.bsModalRef.hide();
  }

  public insertImageQR(fileurl) {
    // tslint:disable-next-line:indent
    this.loading = true;
    this.actionImageQR.emit(fileurl); /// << here you can send object  instead of true
    this.bsModalRef.hide();
    }


 public insertStr(fileurl) {
    // tslint:disable-next-line:indent
    this.loading = true;
    this.actionStr.emit(fileurl); /// << here you can send object  instead of true
    this.bsModalRef.hide();
    }


getPromotion(promotion_id) {
  this._demoService.getPromotion(promotion_id).subscribe(
    data => { this.promotion = data; 
    let res = data[0];
    this.promotion_page_html = res.promotion_page_html;
    this.coupon_id = res.woo_coupon_id;

// console.log('this.template_model.job_type_id ' + this.template_model.job_type_id);

          // console.log('Test: ' + this.template_model.job_type_location_id );
          // loop through template model and setup a search modal.
          this.search_model = {};  

            // Count items of brand search to loop through
            let  count_of_brand_items = Object.keys(this.template_model).length;
            // now loop and push to join model
            for(let i=0;i < count_of_brand_items; i++) {
              let res = this.template_model[i];
            
                // // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                // this.search_model.push({
                //   "is_active": 1,
                //   "job_type_id": res.job_type_id,
                //   // variable_code_block_type_id: '2',
                //   "job_type_location_id": res.job_type_location_id,
                //   "job_type_court_id": res.job_type_court_id,
                //   // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
                //   "variable_code_block_insert_type_id": 2, //pdfs only

                //  });

// need to add -- tp the models neing sent from below.

              if(res.variable_code_block_type_id == ''){
                res.variable_code_block_type_id = 2 // sets to PDF type to show by default
              }

                 this.search_model = {
                  is_active: 1,
                  job_type_id: res.job_type_id,
                  variable_code_block_type_id: res.variable_code_block_type_id,
                  job_type_location_id: res.job_type_location_id,
                  job_type_court_id: res.job_type_court_id,
                  // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
                  // "variable_code_block_insert_type_id": 2, //pdfs only

                 };


                        // {
                        //   "variable_code_block_type_id": "2",
                        //   "is_active": true
                        // }

            
            } // end loop.
            
          let search_model = this.search_model;
          this.getVariableCodeBlocksSearchFull(this.search_model)



    },
    err => console.error(err),
    () => {
      console.log('done loading promotion');
      this.request_query = {
        // page: this.woo_page + 1,
        page: this.woo_page,
        orderby: "id",
        per_page: this.set_items_per_page,
        // per_page: 10 // gets the number of rec
        id: this.coupon_id
        }; 
      this.getWooPPSCouponData(this.request_query); // now get the coupon code
    
    }
  );
}

// Get the woo coupons
// use thses one to get WOO API.... Directly no generated functions. etc.
getWooPPSCouponData(request_query){
  this.productSlug =  ''; // just for now so I can get the id later
  // this.productSlug =  'per_page='+100; // just for now so I can get the id later


  // MUST PASS THE ID in the model.

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: this.set_items_per_page,
//     // per_page: 10 // gets the number of rec
// // action_list_type_id: 1,

//     }; 

// this.params = {slug:this.productSlug}  
  // this.params = {slug: this.request_query }    
  this.params = {slug: request_query } 
  // single           
  let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wc/v3/coupons/' + this.coupon_id, request_query);

            
  // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
  // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
  // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
  // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
  // wc/v3/customers
  this.http.get(wooWebhooksurl)
  .pipe(
    this.toastr.observe({
      loading: '... monkey working ...',
      success: '🚀',
      error: '-'
   })
   )
  .subscribe((wc_ppscoupons_data:any) => { 
  this.woo_ppscoupons = [wc_ppscoupons_data];   // make object.[] - this makes a mulit call single return work in anagular. --wor forboth if remove [] and all coupons call.
  this.woo_ppscoupons_count = this.woo_ppscoupons.length; 
 this.woo_coupon_code = this.woo_ppscoupons[0].code;
 
 
  // this.product = wc_data[0];  
  // this.params = {}
  // let productvariationurl:string = this.woocommerce.authenticateApi('GET',this.brand_wordpress_URL + '/shop/wp-json/wc/v2/products/'+this.product.id+'/variations',this.params);
  // this.http.get(productvariationurl).subscribe((wc_pv_data:any) => {
  //     this.productVariations = wc_pv_data;
  // this.toastr.success('...coupon data loaded');
  });
}



  // santises the html variable saved in the dabase for template output
  // ::@ https://blog.briebug.com/blog/how-do-i-display-html-inside-an-angular-binding
  transform(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }

// ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
}





// Dynamic Variables
getVariableCodeBlocksSearchFull(search_model) {
  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
  this._demoService.getVariableCodeBlocksSearchFull(search_model).subscribe(
    data => { this.variable_code_blocks_metrix_search_full = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     
     
      this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
      // this.subject_service_metrix_search_full_results = data;
      this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 500);

    

    //  this.grid.refresh();
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       

}


} // end
